'use client';

import { Trans } from '@lingui/macro';
import { Container, Stack, Typography } from '@mui/material';
import { Application, ButtonLink } from '@prismo-io/router';
import type { FC } from 'react';
export const PrivateProfileScreen: FC = () => {
  return <Container maxWidth="sm" data-sentry-element="Container" data-sentry-component="PrivateProfileScreen" data-sentry-source-file="index.tsx">
      <Stack justifyContent="center" spacing={5} alignItems="center" minHeight="100vh" data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        <Typography variant="h1" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Profil Privé</Trans>
        </Typography>
        <Stack spacing={3} data-sentry-element="Stack" data-sentry-source-file="index.tsx">
          <Typography variant="h2" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">
              L'utilisateur de ce profil a choisi de le rendre privé. Vous ne
              pouvez pas y accéder. Vous pourrez le consulter lorsqu'il sera de
              nouveau public.
            </Trans>
          </Typography>
        </Stack>
        <ButtonLink app={Application.APP} path="/" queryParams={{
        comingFrom: Application.APP
      }} prefetch={false} variant="contained" color="gradient" loadingOnClick data-sentry-element="ButtonLink" data-sentry-source-file="index.tsx">
          <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Retourner à l'accueil</Trans>
        </ButtonLink>
      </Stack>
    </Container>;
};